import { List } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
const INITIAL_STATE = List();
export default function rootCategoriesOrder(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CLEAR_ORGANIZE_STATE:
      return INITIAL_STATE;
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
    case ActionTypes.FETCH_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS:
      return List(action.payload.categories.map(category => category.id.toString()));
    case ActionTypes.DROP_CATEGORY_ON_CATEGORY:
      {
        const {
          dropCategoryId,
          dragCategoryId,
          dropPosition
        } = action.payload;
        const currentIndex = state.indexOf(dragCategoryId);
        let nextState = state.delete(currentIndex);
        nextState = nextState.insert(dropPosition === 'before' ? nextState.indexOf(dropCategoryId) : nextState.indexOf(dropCategoryId) + 1, dragCategoryId);
        return nextState;
      }
    case ActionTypes.UPDATE_CATEGORY_ORDERING_ERROR:
      {
        const {
          revertInfo: {
            categoryId,
            originalParentIndex
          }
        } = action.payload;
        const currentIndex = state.indexOf(categoryId);
        const nextState = state.delete(currentIndex);
        return nextState.insert(originalParentIndex, categoryId);
      }
    default:
      return state;
  }
}
export const selectRootCategoriesOrder = state => state.organizeRootCategoriesOrder;